// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "babel-polyfill"
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import router from './router'
import axios from 'axios'
import Element from 'element-ui'
import global from './global'
import store from './store/index.js'
import 'element-ui/lib/theme-chalk/index.css'
import 'simple-line-icons/css/simple-line-icons.css'
import 'font-awesome/css/font-awesome.min.css'
import '@/assets/app.css'

Vue.use(Element)
Vue.use(Vuex)
const qs = require('qs');

router.beforeEach((to, from, next) => {
  if(to.meta.title){
    document.title = to.meta.title
  }
  next()
})

const aesjs = require('aes-js');
Vue.prototype.cbc = function (_text) {
  // An example 128-bit key
  var key = aesjs.utils.utf8.toBytes('xrq(1lb*xy#xkr67');

// The initialization vector (must be 16 bytes)
  var iv = aesjs.utils.utf8.toBytes('r$i5e29o&cip7zyw');

// Convert text to bytes (text must be a multiple of 16 bytes)
  var text = _text;
  var realLength = 0;
  var len = text.length;
  var charCode = -1;
  for(var i = 0; i < len; i++){
    charCode = text.charCodeAt(i);
    if (charCode >= 0 && charCode <= 128) {
      realLength += 1;
    }else{
      // 如果是中文则长度加2
      realLength += 3;
    }
  }
  // var count = 16-realLength%16;
  // if(count<16){
  //   for (let i=0;i<count;i++){
  //     text+='\x00'
  //   }
  // }
  var textBytes = aesjs.utils.utf8.toBytes(text);
  var count = 16-textBytes.length%16;
  if(count<16){
    for (let i=0;i<count;i++){
      text+='\x00'
    }
  }
  textBytes = aesjs.utils.utf8.toBytes(text)

  var aesCbc = new aesjs.ModeOfOperation.cbc(key, iv);
  var encryptedBytes = aesCbc.encrypt(textBytes);

// To print or store the binary data, you may convert it to hex
  var encryptedHex = aesjs.utils.hex.fromBytes(encryptedBytes);
  return encryptedHex;

// "104fb073f9a131f2cab49184bb864ca2"

// // When ready to decrypt the hex string, convert it back to bytes
//   var encryptedBytes = aesjs.utils.hex.toBytes(encryptedHex);
//
// // The cipher-block chaining mode of operation maintains internal
// // state, so to decrypt a new instance must be instantiated.
//   var aesCbc = new aesjs.ModeOfOperation.cbc(key, iv);
//   var decryptedBytes = aesCbc.decrypt(encryptedBytes);
//
// // Convert our bytes back into text
//   var decryptedText = aesjs.utils.utf8.fromBytes(decryptedBytes);
//   console.log(decryptedText);
// // "TextMustBe16Byte"
}

axios.defaults.withCredentials = true; //跨域携带cookie

// 添加请求拦截器
axios.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  if(config.method=='put'||config.method=='post'){
    let data = config.data,validation = {
      'password':true,
      'new_passwd':true,
      'old_passwd':true,
      'mdx':true,
      'sql':true,
      'db_passwd':true
    }
    if(config.headers['Content-Type']=='application/x-www-form-urlencoded'){
      data = qs.parse(config.data);
      for (let i in data){
        if(validation[i]){
          data[i] = Vue.prototype.cbc(data[i])
        }
      }
      if(config.method=='put'){
        config.method='post';
        data['_method'] = 'put';
      }
      config.data = qs.stringify(data);
    }else if(config.headers['Content-Type']=='application/json;charset=utf-8'||config.headers['Content-Type']=='application/json'||config.headers['Content-Type']==undefined){
      data = config.data;
      for (let i in data){
        if(validation[i]){
          data[i] = Vue.prototype.cbc(data[i])
        }
      }
      if(config.method=='put'){
        config.method='post';
        data['_method'] = 'put';
      }
    }

  }
  if(config.method=='delete'){
    config.method = 'post';
    config.headers['Content-Type']=='application/x-www-form-urlencoded';
    config.data = qs.stringify({'_method':'delete'});
  }
  return config;
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error);
});


axios.defaults.withCredentials = true;
if (process.env.NODE_ENV === 'development') {
  axios.defaults.baseURL = "/dev-server"
}
Vue.config.productionTip = false;
Vue.prototype.$http = axios;
Vue.prototype.qs = qs;
Vue.prototype.bs = new Vue();
Vue.prototype.global = global

// // 设置默认溢出显示数量
// var spillDataNum = 20;
//
// // 设置隐藏函数
// var timeout = false;
// let setRowDisableNone = function (topNum, showRowNum, binding) {
//   if (timeout) {
//     clearTimeout(timeout);
//   }
//   timeout = setTimeout(() => {
//     binding.value.call(null, topNum, topNum + showRowNum + spillDataNum);
//   });
// };
// Vue.directive('loadmore',{
//   name: 'loadmore',
//   componentUpdated: function (el, binding, vnode, oldVnode) {
//     console.log('dsadsads');
//     setTimeout(() => {
//       const dataSize = vnode.data.attrs['data-size'];
//       const oldDataSize = oldVnode.data.attrs['data-size'];
//       if(dataSize === oldDataSize){
//         return;
//       }
//       const selectWrap = el.querySelector('.el-table__body-wrapper');
//       const selectTbody = selectWrap.querySelector('table tbody');
//       const selectRow = selectWrap.querySelector('table tr');
//       if (!selectRow) {
//         return;
//       }
//       const rowHeight = selectRow.clientHeight;
//       let showRowNum = Math.round(selectWrap.clientHeight / rowHeight);
//
//       const createElementTR = document.createElement('tr');
//       let createElementTRHeight = (dataSize - showRowNum - spillDataNum) * rowHeight;
//       createElementTR.setAttribute('style', `height: ${createElementTRHeight}px;`);
//       selectTbody.append(createElementTR);
//
//       // 监听滚动后事件
//       selectWrap.addEventListener('scroll', function () {
//         let topPx = this.scrollTop - spillDataNum * rowHeight;
//         let topNum = Math.round(topPx / rowHeight);
//         let minTopNum = dataSize - spillDataNum - showRowNum;
//         if (topNum > minTopNum) {
//           topNum = minTopNum;
//         }
//         if (topNum < 0) {
//           topNum = 0;
//           topPx = 0;
//         }
//         selectTbody.setAttribute('style', `transform: translateY(${topPx}px)`);
//         createElementTR.setAttribute('style', `height: ${createElementTRHeight-topPx > 0 ? createElementTRHeight-topPx : 0}px;`);
//         setRowDisableNone(topNum, showRowNum, binding);
//       })
//     });
//   }
// })




/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js